import { rootApi } from "../user/api";

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ["SummaryYard"],
});

export const summaryYardApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findEntrySummaryYard: builder.mutation({
      query: () => `manage_trip/trailer_usage_summary/`,
      keepUnusedDataFor: 0,
      providesTags: ["SummaryYard"],
    }),

    searchChartTotalAndTrailerSummaryYard: builder.mutation({
      query: (payload) =>
        `manage_trip/detail/graph/?working_date=${payload.working_date}&location_from_id=${payload.location_from_id}&plan_job_id=${payload.plan_job_id}&display=sum_all`,
      keepUnusedDataFor: 0,
      providesTags: ["SummaryYard"],
    }),
   //because param --> mode 
    searchChartRegionFilterSummaryYard: builder.mutation({
      query: (payload) =>
        `manage_trip/detail/graph/?working_date=${payload.working_date}&location_from_id=${payload.location_from_id}&plan_job_id=${payload.plan_job_id}&mode=region&region_name=${payload.region_name}&display=sum_region`,
      keepUnusedDataFor: 0,
      providesTags: ["SummaryYard"],
    }),

    searchChartRegionNoFilterSummaryYard: builder.mutation({
      query: (payload) =>
        `manage_trip/detail/graph/?working_date=${payload.working_date}&location_from_id=${payload.location_from_id}&plan_job_id=${payload.plan_job_id}&display=sum_region`,
      keepUnusedDataFor: 0,
      providesTags: ["SummaryYard"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { 
    useFindEntrySummaryYardMutation, 
    useSearchChartTotalAndTrailerSummaryYardMutation,
    useSearchChartRegionFilterSummaryYardMutation,
    useSearchChartRegionNoFilterSummaryYardMutation,
   } =
  summaryYardApi;
